import { useGitlabInstallationV2 } from '../gitlabInstallationV2Context';
import { MultiGroupInstallResults } from './MultiGroupInstallResults';
import { SingleGroupInstallResults } from './SingleGroupInstallResults';

/**
 * Install step entry — routes to the right install flow. Cloud host-only (multi-group)
 * deferred provisioning to here, so it fans out provision → per-group install; every
 * other path (self-managed, legacy single-group cloud) provisioned on Connect and runs
 * the single add-only install. Kept as the stable route element so both flows share one
 * `/install` route.
 */
export const InstallResults = () => {
  const { isMultiGroupCloud } = useGitlabInstallationV2();

  return isMultiGroupCloud ? (
    <MultiGroupInstallResults />
  ) : (
    <SingleGroupInstallResults />
  );
};
